import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from 'src/app/services/gui/modal/modal.service';
import { ClientCullDTO, ClientDTO } from '../../../services/api/api';
import { SbAccessibleClientsComponent } from '../../sb-accessible-clients/sb-accessible-clients.component';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: 'sb-filter-client-cull',
  templateUrl: './sb-filter-client-cull.component.html',
  styleUrls: ['./sb-filter-client-cull.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('200ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(+100%)' }))]),
    ]),
  ],
  standalone: false,
})
export class SbFilterClientCullComponent implements OnInit {
  @Input() cull: ClientCullDTO;
  @Input() easyMode: boolean;
  @Input() disabled: boolean;
  @Input() isInModalContext: boolean;

  @Output() cullChange: EventEmitter<ClientCullDTO> = new EventEmitter<ClientCullDTO>();

  loading: boolean;

  clients: ClientDTO[];

  inverted: boolean;

  constructor(
    public modalService: ModalService,
    public util: UtilService
  ) {
    this.loading = true;
    this.disabled = false;
    this.inverted = false;
    this.clients = [];
  }

  ngOnInit(): void {
    if (this.cull?.staticElements) {
      this.clients = this.cull.staticElements;
      this.inverted = this.cull.invertedStatic;
    } else {
      this.clients = [];
      this.inverted = false;
    }

    this.loading = false;
  }

  addClientRow() {
    this.modalService
      .showNavigationModal({
        entryComponent: { value: SbAccessibleClientsComponent, data: { connectedClients: true } },
        title: null,
        modalOptions: {
          // windowClass: 'bigXL',
          size: 'xl',
        },
      })
      .then((result: ClientDTO) => {
        if (result?.id && !this.clients.find(client => client.id === result.id)) {
          this.addClient(result);
        }
      })
      .catch(() => {});
  }

  addClient(client: ClientDTO) {
    this.clients.push(client);
    this.updateDTO();
  }

  removeClient(index) {
    this.clients.splice(index, 1);
    this.updateDTO();
  }

  emitChange(cull?: ClientCullDTO) {
    this.cullChange.emit(cull ?? this.cull);
  }

  toggleInverted() {
    this.inverted = !this.inverted;
    this.updateDTO();
  }

  updateDTO() {
    this.cull.staticElements = this.clients;
    this.cull.invertedStatic = this.inverted;

    this.emitChange();
  }
}
